import { useAppContext } from '../providers/AppContextWrapper'
import { Applications } from '../utils/application-type'

export const useIsTechnicianApp = () => {
  return useAppContext().appType === Applications.TECHNICIAN
}
